import { JOB_ISSUES_ENDPOINT } from "../../../../consts";
import { useCRUD } from "../../../../api/crud";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useHasPermission } from "../../../../contexts/auth";
import { useBreadcrumbs } from "../../../../components/ui/breadcrumps/breadcrumbsContext";
import { DetailPage } from "../../../../components/ui/detailView";
import { CatalogItemDetail } from "../../catalogItemDetail/catalogItemDetail.component";

export const JobIssueBasicInfo = () => {
  const { id } = useParams();
  const { get } = useCRUD(JOB_ISSUES_ENDPOINT);
  const { setOverride } = useBreadcrumbs();
  const [jobIssue, setJobIssue] = useState<any | null>(null);
  const canViewJobIssues = useHasPermission("service.view_jobissue");

  useEffect(() => {
    const fetchJobIssue = async () => {
      if (id) {
        const response = await get(id);
        if (response.data) {
          setJobIssue(response.data);
          const breadcrumbLabel = response.data.code
            ? `${response.data.title} (${response.data.code})`
            : response.data.title || id;
          setOverride(`/service/issues-catalog/${id}`, breadcrumbLabel);
        }
      }
    };

    const handleJobIssueUpdated = () => {
      fetchJobIssue();
    };

    window.addEventListener("jobIssueUpdated", handleJobIssueUpdated);
    fetchJobIssue();
    return () => {
      window.removeEventListener("jobIssueUpdated", handleJobIssueUpdated);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!canViewJobIssues) {
    return null;
  }

  if (!jobIssue) return <DetailPage loading />;

  return <CatalogItemDetail item={jobIssue} icon={<ReportProblemOutlinedIcon />} />;
};
